import axiosPost from "./axiosPost";

export const MIAConnectionUpd = async (params, credentials) => {
    const body = {
        service: "MIAConnectionUpd",
        params
    };
    console.log(body);
    return await axiosPost(body, credentials);
};
